import { TimeSpan } from "../user-input/user-input.component";

export class TimerHelper {
  static getElapsedTime(from: Date, to: Date): TimeSpan {
    if (from && to) {
      let totalSeconds = Math.floor((to.getTime() - from.getTime()) / 1000);

      let hours = 0;
      let minutes = 0;
      let seconds = 0;

      if (totalSeconds >= 3600) {
        hours = Math.floor(totalSeconds / 3600);
        totalSeconds -= 3600 * hours;
      }

      if (totalSeconds >= 60) {
        minutes = Math.floor(totalSeconds / 60);
        totalSeconds -= 60 * minutes;
      }

      seconds = totalSeconds;

      return {
        hours: hours,
        minutes: minutes,
        seconds: seconds
      };
    }
  }
}
